module.exports = __webpack_public_path__ + "img/xinzhuang-4.b51eb800.jpg";